import { render, staticRenderFns } from "./ImgPartnerLogo.vue?vue&type=template&id=716f7b9a&scoped=true&"
import script from "./ImgPartnerLogo.vue?vue&type=script&lang=js&"
export * from "./ImgPartnerLogo.vue?vue&type=script&lang=js&"
import style0 from "./ImgPartnerLogo.vue?vue&type=style&index=0&id=716f7b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f7b9a",
  null
  
)

export default component.exports